import Cookies from "universal-cookie";
import { httpConfig } from "./httpConfig";
import Swal from "sweetalert2";

const cookies = new Cookies();
const http = httpConfig();
export const ProtectedLogin = async (
  pagelevel,
  intervalWard,
  intervalFilter
) => {
  if (!cookies.get("tokenEstimate")) {
    // console.log("อันนี้ไม่มีข้อมูล TokenEstimate แล้วนี้นา อะ fail");
    // console.log("ตอนนี้ไม่มี token อยู่นะ");

    if (
      window.location.pathname === "/estimate" ||
      window.location.pathname === "/estimate/"
    ) {
      return false;
    } else {
      clearInterval(intervalWard);
      clearInterval(intervalFilter);
      cookies.remove("tokenEstimate");
      localStorage.clear();
      Swal.fire({
        icon: "error",
        title: "!!เข้าสู่ระบบล้มเหลว!!",
        text: "กรุณาลองเข้าสู่ระบบอีกครั้ง",
        showConfirmButton: false,
        timer: 1400,
      });
      setTimeout(() => {
        window.location.href = "/estimate";
      }, 1400);
      return false;
    }
  }
  let token = cookies.get("tokenEstimate");

  let requesttoken = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "content-type": "application/json",
    },
    body: JSON.stringify({ levelpage: pagelevel }),
  };
  let statusProtect = fetch(`${http}/protected`, requesttoken).then((res) =>
    res.json().then((message) => {
      if (message.authstatus) {
        message.data.map((data) => {
          localStorage.setItem(
            "advisor",
            JSON.stringify({
              advisor_id: data.Id,
              advisor_title: data.ttl,
              advisor_name: data.name,
              advisor_lname: data.lname,
              gender: data.sex,
              advisor_start: data.start,
              advisor_stop: data.stop,
            })
          );
        });
        return true;
      } else {
        clearInterval(intervalWard);
        clearInterval(intervalFilter);
        cookies.remove("tokenEstimate");
        localStorage.clear();
        Swal.fire({
          icon: "error",
          title: "!!เข้าสู่ระบบล้มเหลว!!",
          text: "กรุณาลองเข้าสู่ระบบอีกครั้ง",
          showConfirmButton: false,
          timer: 1400,
        });
        setTimeout(() => {
          window.location.href = "/estimate";
        }, 1400);
        // setTimeout(() => {
        //   window.location.href = "/estimate";
        //   cookies.remove("tokenEstimate");
        //   localStorage.clear();
        // }, 1400);
        return false;
      }
    })
  );
  //   console.log(">>>>", await statusProtect);
  return await statusProtect;
};
